import styled from 'styled-components';

/* Faixa no fundo escuro da barra (#2C2C2C): valores em branco, rótulos em
 * cinza-claro, ícones do plano em branco e as bandeiras na cor delas. Abaixo de
 * 1280 px some o rótulo de cada item (fica ícone + valor, rótulo no title);
 * abaixo de 1100 px some também o título dos grupos; no celular (≤ 950 px a
 * barra fica clara e compacta) a faixa não aparece. */

export const StatusBar = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
  min-width: 0;
  font-family: ${(props) => props.theme.font.body.family};

  @media only screen and (max-width: 1280px) {
    gap: 18px;
  }

  @media only screen and (max-width: 950px) {
    display: none;
  }
`;

export const Group = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media only screen and (max-width: 1280px) {
    gap: 12px;
  }
`;

export const GroupLabel = styled.span`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
  white-space: nowrap;

  @media only screen and (max-width: 1100px) {
    display: none;
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

export const ItemIcon = styled.span<{ $color?: string; $muted?: boolean }>`
  display: flex;
  font-size: 18px;
  color: ${(props) =>
    props.$color ??
    (props.$muted
      ? 'rgba(255, 255, 255, 0.45)'
      : props.theme.color.text.inverse)};
`;

export const ItemText = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;

  small {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
  }

  b {
    font-size: 13px;
    color: ${(props) => props.theme.color.text.inverse};
  }

  @media only screen and (max-width: 1280px) {
    small {
      display: none;
    }
  }
`;
